import { FC, useState } from 'react';
import DropdownAutocomplete from 'view/components/DropdownAutocomplete';
import { useGetDropdownData } from 'view/pages/profile/hooks/useGetDropdownData';
import { DropdownsEnum } from 'infrastructure/enums/DropdownsEnum';

const JobCategoryDropdownAutocomplete: FC<any> = ({
  setValue,
  jobCategoryValue,
  label = 'Job Category *',
}) => {
  const [inputValue, setInputValue] = useState('');

  const { data: jobCategoryData, isLoading: isJobCategoryDataLoading } = useGetDropdownData(
    DropdownsEnum.JOB_CATEGORY
  );

  return (
    <DropdownAutocomplete
      label={label}
      value={jobCategoryValue}
      onChange={(value: any) => {
        return setValue('jobCategory', value);
      }}
      inputValue={inputValue}
      setInputValue={setInputValue}
      data={jobCategoryData}
      isLoading={isJobCategoryDataLoading}
      getOptionLabel={(option: any) => {
        return `${option.name}`;
      }}
    />
  );
};

export default JobCategoryDropdownAutocomplete;
